import { useAnalytics } from '#app/hooks/useAnalytics.js';
import { ModalTemplateWrapper } from '../ModalTemplateWrapper/ModalTemplateWrapper.js';
import { type CommonTemplateProps } from '../types.js';
import { type ReactNode, useCallback } from 'react';

type PreviewJobPostingModalProps = {
  readonly children: ReactNode;
  readonly closeModal: CommonTemplateProps['closeModal'];
  readonly isOpen: CommonTemplateProps['isOpen'];
  readonly modalName: CommonTemplateProps['modalName'];
};

export const PreviewJobPostingModal = ({
  children,
  closeModal,
  isOpen,
  modalName,
}: PreviewJobPostingModalProps) => {
  const { track } = useAnalytics();

  const handleOnClose = useCallback(() => {
    closeModal();

    track('modal', {
      action: 'tapped',
      cta: 'close',
      modal_name: modalName,
    });
  }, [closeModal, modalName, track]);

  return (
    <ModalTemplateWrapper
      ariaLabel="Preview Job Posting"
      ctaOptions={{
        primaryCTA: {
          handleOnClick: handleOnClose,
          label: 'Close Preview',
        },
      }}
      desktopModalSize="xlarge"
      isFullscreenOnMobile
      isOpen={isOpen}
      onClose={handleOnClose}
    >
      <>{children}</>
    </ModalTemplateWrapper>
  );
};
